<template>
    <div class="">
        <div class="edit-row">
            <div class="details-title">Name</div>
            <div class="remote-btns">
                <el-button
                    type="primary"
                    class="gcmcn-primary-btn small remote-btn"
                    @click="editDetails"
                >Edit</el-button>
                <el-popover
                    ref="popover"
                    placement="bottom"
                    width="148"
                    trigger="click"
                    popper-class="dark-popper"
                    @hide="hideDeletePopover"
                >
                    <div>
                        <div class="popover-title">Confirm receiver deletion</div>
                        <div class="actions">
                            <el-button type="text" class="decline" @click="hideDeletePopover()">No</el-button>
                            <el-button type="text" class="accept" @click="removeManualReceiver()">Yes</el-button>
                        </div>
                    </div>
                    <el-button
                        slot="reference"
                        type="danger"
                        class="gcmcn-danger-btn small"
                        @click="popOverOpenned = true"
                    >Delete</el-button>
                </el-popover>
            </div>
        </div>
        {{ manualReceiver.name }}
        <div class="details-title top-space">Taker</div>
        {{ relatedTaker.name }}
        <div class="details-title top-space">Entity</div>
        <div class="receiver-entity">
            <img :src="entity.logo">
            <div>{{ entity.display_name }}</div>
        </div>
        <div class="details-title top-space">Latency</div>
        <span
            v-if="manualReceiver.latency === 0"
        >
            No latency
        </span>
        <span
            v-else
        >
            {{ manualReceiver.latency }}ms
        </span>
        <div class="details-title top-space">Encryption</div>
        <span
            v-if="manualReceiver.decryption_type === ''"
        >
            No encryption
        </span>
        <span
            v-else
        >
            {{ manualReceiver.decryption_type }}
        </span>
        <div
            v-if='!isListenerReceiver'
        >
            <div class="details-title top-space">Public IPs (CIDR)</div>
            <div
                v-if="manualReceiver.public_ips.length === 0"
                class="feed-info-value"
            >
                {{manualReceiver.public_ip}}

            </div>
            <div
                v-else
                v-for="(public_ip,index) in manualReceiver.public_ips"
                :key="index"
                class="feed-info-value"
            >
                {{public_ip}}
            </div>
            <div class="details-title top-space" v-if="this.manualReceiver.source_protocol_type === 'zixi'">Remote ID</div>
            <div v-if="this.manualReceiver.source_protocol_type === 'zixi'">{{ manualReceiver.remote_id }}</div>
        </div>
        <div
            v-if="isSrt"
        >
            <div
                v-if="isListenerReceiver"
            >
                <div class="details-title top-space">Primary port</div>
                <span>{{manualReceiver.primary_port}}</span>
                <div class="details-title top-space">Secondary port</div>
                <span>{{manualReceiver.secondary_port}}</span>
                <div class="details-title top-space">Destination</div>
                <span>{{manualReceiver.destination}}</span>
            </div>
            <div
                v-else
            >
                <div class="details-title top-space">Port</div>
                <span>{{manualReceiver.primary_port}}</span>
            </div>
        </div>


    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {

    components: {

    },

    props: {
        manualReceiver: {
            type: Object,
            required: true,
        },
    },

    data (){
        return {
            popOverOpenned: false,
        };
    },

    computed: {
        ...mapGetters([
            'entitiesByUid',
            'takersByUid'
        ]),
        relatedTaker (){
            return this.$store.getters.takersByUid(this.manualReceiver.taker_uid);
        },
        entity (){
            return this.entitiesByUid(this.manualReceiver.scopes.entity_uid);
        },
        isListenerReceiver(){
            return this.manualReceiver.source_protocol_type.includes('listener');
        },
        isSrt(){
            return this.manualReceiver.source_protocol_type.includes('srt')
        }
    },

    mounted (){

    },

    methods: {
        editDetails (){
            this.$emit('edit-manual-receiver');
        },
        removeManualReceiver (){
            // this.$confirm('This will delete the manual receiver. Continue?', 'Warning', {
            //     confirmButtonText: 'Yes',
            //     cancelButtonText: 'No',
            //     type: 'warning'
            // }).then(() => {
                this.$store.dispatch('patchItem', {
                    item: {
                        archived: true,
                        url: this.manualReceiver.url
                    },
                    model: 'manualReceivers',
                }).then(() => {
                    this.$emit('on-manual-receiver-deleted');
                    this.$store.dispatch('fetchModelByName', 'manualReceivers');
                    this.$message({
                        type: 'success',
                        message: 'Delete completed'
                    });
                }).catch((e) => {
                    console.error(e);
                    this.$message({
                        type: 'error',
                        message: 'Error on manual receiver delete'
                    });
                });
            // }).catch(() => {});
        },
        hideDeletePopover() {
            this.popOverOpenned = false;
            if (this.$refs['popover']) {
                this.$refs['popover'].showPopper = false;
            }
        },
    },
};
</script>

<style lang="scss">
.remote-btns{
    float: right;

    // right: 10em;
}
.receiver-entity{
    display: flex;
    align-items: center;
    margin-top: 20px;
    img{
        width: 80px;
    }
    div{
        font-size: 18px;
        font-weight: bold;
        margin-left: 1rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Receiver/Manual/manualReceiverDetails.vue